// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './style.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

// Create a separate initialization function
const initializeDarkMode = async () => {
  const { useDarkModeStore } = await import('./store/darkMode')
  const darkModeStore = useDarkModeStore()
  darkModeStore.initialize()
}

// Mount first, then initialize dark mode
app.mount('#app')
initializeDarkMode()